import { formatLocalStepData } from './convertStepFilterData';

const stepsFilterBeforeUpdateQuery = ({ combinedStepStatusTitles, ...rest }) => ({
	combinedStepStatusTitles: formatLocalStepData(combinedStepStatusTitles),
	...rest,
});

export default stepsFilterBeforeUpdateQuery;
